import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div className="mjs-footer">
                <div className="mjs-footer-copyright"> 
                © {new Date().getFullYear()} <a href="https://statefolio.com/" target="_blank">StateFolio</a>. All Rights Reserved.
                </div>
                <div className="mjs-footer-links">
                <a href="https://statefolio.com/privacy-policy/" target='_blank'>Terms and Privacy Policy</a>
                </div>
            </div>
        );
    }
}
export default Footer;
